<template>
<div>
            <footer class="bg-dark">
            <div class="container">
                <div class="row justify-content-center">

                    <div class="col-xl-4 col-md-4 col-lg-4">

                      <h3 class="footer_title" style="margin-bottom: 20px">部分用户案例
                      </h3>
                      <li style="color: #FFFFFF;">
                        高校:<br/>
                        复*大学 &emsp;&emsp;厦*大学 &emsp;&emsp;西*大学 &emsp;&emsp;长*大学 &emsp;&emsp;中央**大学&emsp;&emsp;广东外语**大学 <br/>
                        杭州**科技大学 &emsp;&emsp;江西**大学 &emsp;&emsp;南京**大学 &emsp;&emsp;山东**大学 &emsp;&emsp;中原*学院 <br/>
                       上海**会计金融学院 &emsp;&emsp;浙江**职业技术学院<br/>
                        <br/>
                        企业:<br/>
                        厦门**科技 &emsp;&emsp;贵州***实业 &emsp;&emsp;广州**科技 &emsp;&emsp;上海超奕**公司<br/>
                        河北**艺术工坊 &emsp;&emsp;**光电科技 &emsp;&emsp;**村镇银行 &emsp;&emsp;上海**物流<br/>
                      </li>
                    </div>
                    <!-- <div style="margin-top:15px;" class="col-xl-2 offset-xl-3 col-md-1 col-lg-2"> -->
                    <div class="col-xl-4 col-md-4 col-lg-4">
                      <div class="footer_widget ml-5" style="">
                        <h3 class="footer_title" style="margin-bottom: 20px">
                          关于我们
                        </h3>
                        <ul>
                          <li style="padding:5px 0;"><router-link style="color: #FFFFFF;" to="/us">公司简介</router-link></li>
<!--                          <li style="padding:5px 0;"><router-link style="color: #FFFFFF;" to="/team">核心团队</router-link></li>-->
                          <li style="padding:5px 0;"><router-link style="color: #FFFFFF;" to="/timeline">发展历程</router-link></li>
                          <li style="padding:5px 0;"><router-link style="color: #FFFFFF;" to="/certificate">资质证书</router-link></li>
                          <li style="padding:5px 0;"><router-link style="color: #FFFFFF;" to="/responsibility">企业社会责任</router-link></li>
<!--                          <li style="padding:5px 0;"><a href="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/%E7%88%B1%E6%8B%BC%E8%80%83%E4%BA%A7%E5%93%81%E5%AE%A3%E4%BC%A0%E6%89%8B%E5%86%8C%EF%BC%882021%E5%B9%B47%E6%9C%88%E7%89%88%EF%BC%89.pdf" style="color: #FFFFFF;" >产品宣传手册</a></li>-->
                          <li style="padding:5px 0;"><router-link style="color: #FFFFFF;" to="/privacy">隐私条例&法律声明</router-link></li>
                        </ul>
                      </div>
                    </div>

                  <div class="col-xl-4 col-md-4 col-lg-3">
                    <div class="footer_widget">
                      <h3 class="footer_title">
                        扫码关注
                      </h3>
                      <div class="socail_links">
                        <div class="socail_links-div">
                          <img style="width:130px;height:130px;" src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/gongzonghao.jpg" />
                          <div style="color:#fff;font-size: 12px;margin-top:10px;text-align: center;width:130px;">
                            (微信公众号：爱拚氪)</div>
                        </div>
                        <div style="margin-left: 40px;">
                          <img style="width:130px;height:130px;" src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/xiaochengxu.jpg" />
                          <div style="color:#fff;font-size: 12px;margin-top:10px;text-align: center;width:130px;">
                            (微信小程序：爱拼考)</div>
                        </div>

                      </div>
                      <div style="width:265px;display:flex;justify-content:space-between;margin-left: 25px;margin-top:20px;">
                      </div>
                    </div>
                  </div>
                </div><!--end row-->
            </div><!--end container-->
            <!-- Back to top -->
            <router-link to="#top" class="back-to-top" id="back-to-top" title="Top">
                <i class="mdi mdi-arrow-up icons bg-light text-dark"> </i>
            </router-link>
            <!-- Back to top -->
        </footer><!--end footer-->
        <footer class="footer-bar bg-dark">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 text-center">
                        <p class="mb-0 footer-text para-desc mx-auto"> Copyright ©2020-{{ new Date().getFullYear() }} 上海爱拚氪数字科技有限责任公司版权所有 建议使用IE8+，Chrome，Firefox或者其他高级浏览器，1024*768分辨率 </p>
                      <p class="mb-0 footer-text para-desc mx-auto"><a style="color: white"  target="_blank"  href="https://exam.ipeakexam.com/privacy/privacy.html?tag=SHRadioAndTelevisionProgramProductionAndOperationLicense">广播电视节目制作经营许可证：(沪)字第05192号</a></p>
                      <p class="mb-0 footer-text para-desc mx-auto" ><a style="color: white" href="https://beian.miit.gov.cn">沪ICP备20015263号-2 </a><img style="height: 20px;width:20px;" src="http://cbpass.cn-bj.ufileos.com/exam%2Fjingcha.png"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502015371" style="color: white"> 沪公网安备 31011502015371号</a></p>
                    </div><!--end col-->
                </div><!--end row-->
            </div><!--end container-->
        </footer><!--end footer-->
        </div>
</template>
<!--<script type="text/javascript" src="https://vf.knet.cn/seallogo.dll?sn=e992150110000523790260000&h=47"></script>-->
<script>
export default {

}
</script>
<style>
.footer_title{
  font-size: 14px;
  color: #fbf9ff;
}
</style>
